var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAws(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 333 201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.4 129.6l-6.3 18.8h-.2l-6.6-18.8H66.5l13.1 30.1-2.8 6.2c-1.3 2.9-3.2 4.3-6.7 4.3-2 0-4.3-.6-5.9-1.3l-3.8 11.5c2.9 1.3 6.8 2 10.7 2 10.1 0 15.5-4.6 20.2-17.8l15.4-35h-13.3zm98.3-10.4c-12.3 0-19.5 7.5-19.5 17.6 0 8.4 5.1 14.3 17 17.8 5.2 1.6 7.1 2.6 7.1 5 0 2.5-2.2 3.7-6.5 3.7-4.9 0-10.8-2-15.6-5.1l-5.7 11.3c5.4 3.6 12.7 5.8 21 5.8 12.9 0 20.8-6.5 20.8-17.7 0-8.6-5.1-14.2-16.2-17.5-6.3-1.9-8.1-2.9-8.1-5.1 0-2.1 2-3.5 5.9-3.5 4.2 0 8.9 1.6 13.5 4.1l5.8-11.2c-4.8-2.9-11.3-5.2-19.5-5.2zm-188.8 34v-16.5h11.7v-12.3h-11.7v-18.5l-13.9 2.9v15.6h-8.4v12.3h8.4v18.8c0 10 5.5 16.7 16.1 16.7 4.2 0 8.7-1 11.9-2.5l-2.7-11.2c-2.1 1-4.7 1.6-7.1 1.6-3.9 0-4.3-2.6-4.3-6.9zm234.5-34c-6.2 0-10.5 2.3-13.5 7.3l-1.8-6.3h-11.7v59.3h13.9v-14.3c3 3.8 7 5.8 12.5 5.8 10.5 0 20.6-8.4 20.6-26.2 0-16.4-8.8-25.6-20-25.6zm-3.4 39.2c-5.8 0-10.1-4.8-10.1-13.9 0-9.3 4.2-13.8 10.1-13.8 6.1 0 10 4.7 10 13.8 0 9.1-3.9 13.9-10 13.9zm-83.8-39.2c-14.1 0-23.4 10-23.4 26.2 0 17.3 10.6 25.6 25 25.6 7.2 0 13.3-1.6 18.6-6.2l-7.2-9.1c-2.9 2.1-6.2 3.4-9.9 3.4-5.3 0-10.3-2.7-11.7-10.2h30.6v-5.7c0-17.8-9.5-24-22-24zm-.3 12.7c3.9 0 7.5 2.5 8.3 9.2h-17.4c1-6.5 4.7-9.2 9.1-9.2zm-42.1-11.7l-6.2 22.6-6.5-22.6h-14.5l-6.4 22.6-6-22.6H55.1l14.3 48.4h14.6l6.7-19.4 6.5 19.4h14.8l14.1-48.4z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.9 104l44.9 16v-31.8z",
    fill: "#f7a80d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.9 88.2v15.7l44.9 16 .1-31.7z",
    fill: "#bd5b1d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3 95.4l-21.3 7.6V72.3z",
    fill: "#f7a80d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3 72.3v23.1l-21.3 7.6V72.3z",
    fill: "#bd5b1d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M190.4 51.5l-28.6 8.3V28.7z",
    fill: "#f7a80d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M161.8 28.7v31.2l28.6-8.4V28.7z",
    fill: "#bd5b1d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.3 119.9h133.5v17.3H105.3z",
    fill: "#f7a80d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAws);
export default __webpack_public_path__ + "static/media/aws.bfdeb37b7b5f63c0205c39fe3256f3c8.svg";
export { ForwardRef as ReactComponent };